export const FETCH_COUNTRIES_PENDING = 'FETCH_COUNTRIES_PENDING';
export const FETCH_COUNTRIES_FULFILLED = 'FETCH_COUNTRIES_FULFILLED';
export const FETCH_COUNTRIES_FAILED = 'FETCH_COUNTRIES_FAILED';
